import React from 'react';
import {
   List, Datagrid, TextField,
} from 'react-admin';
import PackagesFilter from './PackagesFilter';
import PackageUpdateButton from './PackageUpdateButton';

const PackagesList = (props) => (
   <List {...props} filters={<PackagesFilter />}>
      <Datagrid>
         <TextField source="name" />
         <TextField source="url" />
         <PackageUpdateButton />
      </Datagrid>
   </List>
);
export default PackagesList;
